export default {
  root: {
    marginBottom: '0.5em',
    paddingBottom: '1em'
  },
  marginDense: {
    margin: '0 !important',
    marginTop: '8px !important',
    padding: 0
  }
};
